import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @description 列表按钮组件
 */
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import styles from './index.module.less';
export const OperationBtn = (props) => {
    const { btns, rowInfo, rowIndex, showNum = 3 } = props;
    const getFilterBtns = () => {
        const list = [];
        if (btns && btns.length > 0) {
            btns.forEach((item) => {
                const curItem = {};
                Object.assign(curItem, item);
                curItem.show = true;
                if (item.visibled) {
                    curItem.show = item.visibled(rowInfo, rowIndex);
                }
                if (curItem.show) {
                    list.push(curItem);
                }
            });
        }
        return list;
    };
    const toPath = (data) => {
        if (data.click) {
            data.click(rowInfo, rowIndex);
        }
    };
    /*监听*/
    const curBtns = useMemo(() => {
        return getFilterBtns();
    }, [btns, rowInfo]);
    const menus = () => (_jsx(Menu, { children: curBtns &&
            curBtns.map((more, mIndex) => {
                return (showNum &&
                    mIndex > showNum - 2 && (_jsx(Menu.Item, { onClick: () => toPath(more), children: _jsx("a", { style: {
                            color: "var( --lj-primary-color )"
                        }, children: typeof more.title === 'function'
                            ? more.title(rowInfo, mIndex)
                            : more.title }) }, mIndex)));
            }) }));
    return (_jsxs("div", { style: { display: 'inline-block' }, children: [curBtns &&
                curBtns.map((item, index) => {
                    return showNum &&
                        (index < showNum - 1 || curBtns.length == showNum) ? (_jsx("div", { className: `${styles.operationBtnItem} operationBtnItem`, style: { display: 'inline-block' }, children: _jsx("a", { onClick: () => toPath(item), children: typeof item.title === 'function'
                                ? item.title(rowInfo, index)
                                : item.title }) }, index)) : ('');
                }), showNum && curBtns.length > showNum && (_jsx("div", { className: `${styles.operationBtnItem} operationBtnItem`, style: { display: 'inline-block' }, children: _jsx(Dropdown, { overlay: menus, children: _jsxs("a", { onClick: (e) => e.preventDefault(), children: ["\u66F4\u591A ", _jsx(DownOutlined, {})] }) }) }))] }));
};
